import { merge, timer } from "rxjs";
import { filter, mapTo, switchMap } from "rxjs/operators";
import { TypeActionScene } from "../../../scenes/actionScenes";
import { IdScene } from "../../../scenes/types/IdScene";
import { actionGameTrackingUpdateFps } from "../../actionGameTracking";
import { IdGameTrackingFpsEventName } from "../IdGameTrackingFpsEventName";
var fpsTimeStreamData = [
    { eventTime: "1", time: 60000 },
    { eventTime: "5", time: 300000 },
    { eventTime: "10", time: 600000 },
];
export var epicGameTrackingFpsMemoryUsagePlayTime = function (action$, state$, deps) {
    return action$.pipe(filter(function (action) {
        return action.type === TypeActionScene.RequestSwap &&
            action.sceneId === IdScene.PlayerBase;
    }), switchMap(function () {
        var mapFpsTimeStateToStream = function (val) {
            return timer(val.time).pipe(mapTo(actionGameTrackingUpdateFps(IdGameTrackingFpsEventName.X_MINUTE.replace("{X}", val.eventTime))));
        };
        var timeStream = fpsTimeStreamData.map(mapFpsTimeStateToStream);
        return merge.apply(void 0, timeStream);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/game-tracking/fps/epics/epicGameTrackingFpsMemoryUsagePlayTime.ts
// module id = 1864
// module chunks = 3